module.exports = __webpack_public_path__ + "static/media/GT06_ST_Boards.5921f01a.csv";